<div class="initial-setup-page">
    <div class="content" *ngIf="!existingUserForgotPassword; else forgotPasswordContainer">
        <h1>Welcome to EZ DOCS</h1>

        <p>
            You are the first person from
            <strong>{{ dealerName }} ({{ dealerCode }})</strong> to access EZ DOCS. Please complete the form below and confirm that you are authorized to set up
            this location and have system administrator rights.
        </p>

        <p>
            <strong
                ><em
                    >System Administrators have full rights to all available functions within the application, as well as the ability to update the dealership's
                    profile and manage users.</em
                ></strong
            >
        </p>

        <p>If you are not the right person to set up your dealership, click Cancel and forward the link to the appropriate person.</p>

        <p *ngIf="existingUser && !existingUserIsCustomer" class="existing-user">
            You already have a user profile in the system. Please review the information below and update it if necessary. Please enter your password to
            continue.
        </p>
        <p *ngIf="existingUser && existingUserIsCustomer" class="existing-user">
            This email address is already used in the system as a customer and cannot be used for your dealer user account. Please enter a different email
            address.
        </p>

        <form [formGroup]="initialDealerSetupForm">
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input class="dealer-code" matInput formControlName="email" (change)="checkIfUserExistsForEmail()" />
            </mat-form-field>
            <div class="form-group-layout-1">
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input class="dealer-code" matInput formControlName="firstName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input class="dealer-code" matInput formControlName="lastName" />
                </mat-form-field>
            </div>
            <div class="form-group-layout-2">
                <mat-form-field>
                    <mat-label>Mobile Phone (required for 2 factor auth)</mat-label>
                    <input class="dealer-code" matInput appPhoneMask placeholder="(XXX) XXX-XXXX" maxlength="14" formControlName="mobilePhone" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Job Title</mat-label>
                    <mat-select [(value)]="jobTitleControl" placeholder="Select users' Job Title" formControlName="jobTitle">
                        <mat-option [value]="title.jobTitle" *ngFor="let title of jobTitlesThatCanAcceptDpa">{{ title.jobTitle }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <accept-terms
                *ngIf="!existingUser"
                (outEvent)="acceptTermsCallback($event)"
                [requiredDocs]="requiredDocs"
                [showTitle]="false"
                [showButtons]="false"
                [initiallyChecked]="true"
            >
                <!-- These are only needed for new users, existing users would have already accepted them -->
            </accept-terms>
        </form>

        <password
            *ngIf="existingUser"
            [onPasswordValid]="handlePasswordValid"
            [onPasswordInvalid]="handlePasswordInvalid"
            [showTitle]="false"
            [showRequirements]="false"
            [hideConfirmPassword]="true"
            [requirementsAboveFields]="false"
        ></password>

        <div class="links" *ngIf="existingUser">
            <a style="color: var(--tenant-header)" (click)="forgotPassword()">Reset Password</a>
            (You will return to this page after resetting your password)
        </div>

        <div>
            <p>If you have any questions or need help, please reach out to us.</p>

            <div class="support-wrap">
                <p><b>EZ DOCS Support</b></p>
                <p>Phone: {{ tenantSupportPhone }}</p>
                <p>Email: {{ tenantSupportEmail }}</p>
                <p><em>Our support team is available Monday through Friday from 8am to 8pm and Saturdays from 10am to 6pm (all times Eastern).</em></p>
            </div>
        </div>

        <div class="btn-wrap">
            <button mat-button class="secondary" (click)="cancel()">Cancel</button>
            <button mat-button class="primary" [disabled]="!formValid()" (click)="save()">Save and Continue</button>
        </div>
    </div>
</div>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>

<ng-template #forgotPasswordContainer>
    <div class="content">
        <div>
            <password
                [onPasswordValid]="handlePasswordValid"
                [onPasswordInvalid]="handlePasswordInvalid"
                [showTitle]="true"
                [showRequirements]="true"
                [hideConfirmPassword]="false"
                [requirementsAboveFields]="false"
            ></password>
        </div>

        <div class="btn-wrap">
            <button mat-button class="secondary" (click)="cancelForgotPassword()">Cancel</button>
            <button mat-button class="primary" [disabled]="!validPassword" (click)="resetPassword()">Reset Your Password</button>
        </div>
    </div>
</ng-template>
